import { API_CONFIG, getApiUrl, getAuthHeaders } from './config/api';
import { PatientListItem } from './types';

export interface PatientFamilyLink {
  id: number;
  patientId: number;
  relatedPatientId: number;
  relationship: string;
  relatedPatient?: PatientListItem;
}

export const FamilyLinkApi = {
  async list(token: string, patientId: number): Promise<PatientFamilyLink[]> {
    const res = await fetch(getApiUrl(API_CONFIG.ENDPOINTS.FAMILY_LINKS, { patientId }), { headers: getAuthHeaders(token) });
    if (!res.ok) throw new Error('Failed to load family links');
    return res.json();
  },
  async add(token: string, patientId: number, relatedPatientId: number, relationship: string) {
    const res = await fetch(getApiUrl(API_CONFIG.ENDPOINTS.FAMILY_LINKS, { patientId }), { method: 'POST', headers: getAuthHeaders(token), body: JSON.stringify({ relatedPatientId, relationship }) });
    if (!res.ok) throw new Error('Failed to add family link');
  },
  async remove(token: string, patientId: number, linkId: number) {
    const res = await fetch(getApiUrl(API_CONFIG.ENDPOINTS.FAMILY_LINK_DELETE, { patientId, linkId }), { method: 'DELETE', headers: getAuthHeaders(token) });
    if (!res.ok) throw new Error('Failed to remove family link');
  },
  async setResponsible(token: string, patientId: number, responsibleId: number) {
    const res = await fetch(getApiUrl(API_CONFIG.ENDPOINTS.SET_RESPONSIBLE, { patientId, responsibleId }), { method: 'PUT', headers: getAuthHeaders(token) });
    if (!res.ok) throw new Error('Failed to assign responsible party');
  }
};
